import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadStore } from '../../../redux/modules/store';
import AmexIcon from './icone_pagamenti/Amex';
import BonificoIcon from './icone_pagamenti/Bonifico';
import ContrassegnoIcon from './icone_pagamenti/Contrassegno';
import MastercardIcon from './icone_pagamenti/Mastercard';
import PaypalIcon from './icone_pagamenti/Paypal';
import VisaIcon from './icone_pagamenti/Visa';
import VisaElectronIcon from './icone_pagamenti/VisaElectron';

class MetodiPagamento extends Component {
  componentDidMount() {
    this.props.loadStore();
  }

  render() {
    let tipoPagamenti = [
      {
        id: 0,
        name: 'Amex',
        img: <AmexIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasAmex,
      },

      {
        id: 1,
        name: 'Bonifico Bancario',
        img: <BonificoIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasBank,
      },

      {
        id: 2,
        name: 'Contrassegno',
        img: <ContrassegnoIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasDelivery,
      },

      {
        id: 3,
        name: 'Mastercard',
        img: <MastercardIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasMastercard,
      },

      {
        id: 4,
        name: 'Paypal',
        img: <PaypalIcon style={{ width: 48, height: 24 }} />,
        on: this.props.hasPaypal,
      },

      {
        id: 5,
        name: 'Visa Electron',
        img: <VisaElectronIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasElectron,
      },

      {
        id: 6,
        name: 'Visa',
        img: <VisaIcon style={{ width: 40, height: 24 }} />,
        on: this.props.hasVisa,
      },
    ];

    const listaSpedizioni = tipoPagamenti
      .filter(item => item.on)
      .map(item => item.img);

    return (
      <div className="pad-left" style={{ display: 'flex', gap: 8 }}>
        {listaSpedizioni}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasAmex: state.store.data.funzionalita.allowAmexLogo,
  hasBank: state.store.data.funzionalita.allowBankTransferLogo,
  hasDelivery: state.store.data.funzionalita.allowDeliveryLogo,
  hasMastercard: state.store.data.funzionalita.allowMastercardLogo,
  hasPaypal: state.store.data.funzionalita.allowPaypalLogo,
  hasElectron: state.store.data.funzionalita.allowVisaElectronLogo,
  hasVisa: state.store.data.funzionalita.allowVisaLogo,
});

export default connect(mapStateToProps, { loadStore })(MetodiPagamento);
